import { render } from "./BubbleRule.vue?vue&type=template&id=2a61c674&scoped=true"
import script from "./BubbleRule.vue?vue&type=script&lang=js"
export * from "./BubbleRule.vue?vue&type=script&lang=js"

import "./BubbleRule.vue?vue&type=style&index=0&id=2a61c674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a61c674"]])

export default __exports__